var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.data.subtype,{tag:"component",staticClass:"header",domProps:{"innerHTML":_vm._s(_vm.data.label)}})}
var staticRenderFns = []

export { render, staticRenderFns }